import React from 'react';

/**
 * Sticky top banner. Announces that this entire showroom is a Free Builder
 * reference demo. Stays visible on every page of /memberships/. Subtle continuous
 * animation: a sweeping shine and a pulsing dot, no UI distraction.
 */
export default function FrameworkBanner() {
  return (
    <a
      href="https://free-builder.com"
      className="fb-banner"
      aria-label="Built with the Free Builder framework. Visit free-builder.com."
    >
      <div className="fb-banner-inner">
        <span className="fb-banner-dot" aria-hidden="true" />
        <span className="fb-banner-text">
          <strong>This entire membership-sales platform</strong> was built using the
          {' '}<strong>Free Builder framework</strong> as a live demo.
          {' '}<span className="fb-banner-cta">See the framework →</span>
        </span>
      </div>
      <span className="fb-banner-shine" aria-hidden="true" />
    </a>
  );
}
